import { Input } from "@/domains/shared/components/Input";
import { Label } from "@/domains/shared/components/Label";
import { formatCpfDisplay, isValidCpf, normalizeCpfDigits } from "@/domains/shared/validation/cpf";
import { useId } from "react";

type CpfInputProps = {
    value: string;
    onChange: (value: string) => void;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    label?: string;
    className?: string;
    inputTestId?: string;
};

export default function CpfInput({
    value,
    onChange,
    required = false,
    disabled = false,
    readOnly = false,
    label = "CPF",
    className,
    inputTestId,
}: CpfInputProps) {
    const id = useId();

    return (
        <div className={className}>
            <Label htmlFor={id} className="text-sm font-medium text-foreground">
                {label}
                {required ? " *" : null}
            </Label>
            <Input
                id={id}
                data-testid={inputTestId}
                value={formatCpfDisplay(value)}
                onChange={(e) => onChange(normalizeCpfDigits(e.target.value))}
                placeholder="000.000.000-00"
                inputMode="numeric"
                autoComplete="off"
                required={required}
                disabled={disabled}
                readOnly={readOnly}
                aria-readonly={readOnly ? true : undefined}
                maxLength={14}
                className={`mt-2${readOnly ? " bg-muted/40" : ""}`}
            />
        </div>
    );
}

export function validateCpfField(value: string, required: boolean): string | null {
    if (!value.trim()) {
        return required ? "Informe o CPF." : null;
    }
    if (!isValidCpf(value)) {
        return "CPF inválido.";
    }
    return null;
}
